// src/modules/clinical-info/clinical-info.routes.js

import { Navigate } from "react-router-dom";
import ClinicalInfoPageContainer from "./pages/ClinicalInfoPageContainer";
import DischargedPage from "./pages/discharged/DischargedPage";
import AdmittedPage from "./pages/admitted/AdmittedPage";
import EmergencyPage from "./pages/emergency/EmergencyPage";
// High Cost migró a un módulo independiente (src/modules/high-cost). La ruta
// vieja queda como redirect para no romper bookmarks.
import HighRiskPage from "./pages/high-risk/HighRiskPage";

/**
 * Routes configuration for the clinical-info module
 */
export const clinicalInfoRoutes = [
  {
    path: "/ClinicalInfo",
    element: <ClinicalInfoPageContainer />,
  },
  {
    path: "/clinical-info/discharged",
    element: <DischargedPage />,
  },
  {
    path: "/clinical-info/admitted",
    element: <AdmittedPage />,
  },
  {
    path: "/clinical-info/emergency",
    element: <EmergencyPage />,
  },
  {
    path: "/clinical-info/high-cost",
    element: <Navigate to="/high-cost" replace />,
  },
  {
    path: "/clinical-info/high-risk",
    element: <HighRiskPage />,
  },
];

export default clinicalInfoRoutes;
